import React from "react"

import ComponentFactory from "../components/parsers/ComponentFactory"

import * as textSliderSectionStyles from "../styles/TextSliderSection.module.css"

/**
 * Parsing of UL with list items that act as navigaton selectors
 */
const sliderNav = content => {
  const sliderNavNode = content.childNodes.filter(
    node => node.classNames === "slider-section-nav"
  )[0]
  const sliderNavElems = (sliderNavNode && sliderNavNode.childNodes) || []

  const sliderItems = sliderNavElems.map((elem, indx) => ({
    id: `slider-section-nav-${indx + 1}`,
    label: elem.childNodes[0].text,
  }))

  return sliderItems
}

const categorizedCtas = components => {
  let ctas = {}

  components
    .filter(c => c.type !== `div`)
    .forEach(cta => {
      const navElem = cta.props.content.childNodes.filter(node =>
        node.classNames.trim().split(/\s+/).includes("text-slider-navigator")
      )[0]

      if (!navElem) return

      const category = navElem.classNames
        .trim()
        .split(/\s+/)
        .filter(c => c.startsWith(`slider-section-nav`))[0]

      ctas[category] = ctas[category] || []
      ctas[category].push(cta)
    })

  return ctas
}

export default function TextSliderSection(props) {
  const { content } = props

  const components = ComponentFactory(content.innerHTML)

  const title = components.filter(
    c => c.props.className === `icw-slider-section-title`
  )[0]

  const ctas = categorizedCtas(components)

  const sliderItems = sliderNav(content)

  const [category, setCategory] = React.useState(Object.keys(ctas)[0])

  return (
    <div
      className={`row ${textSliderSectionStyles.wrapper} ${props.className}`}
    >
      <div className={`col-12`}>
        <div className={`row`}>
          <div className={`col-4 ${textSliderSectionStyles.title}`}>
            <>{title}</>
          </div>
        </div>

        <div className={`row ${textSliderSectionStyles.ctaGroup}`}>
          {category &&
            ctas[category].map((cta, indx) => (
              <div
                key={indx}
                className={`col-8 col-xl-4 ${textSliderSectionStyles.ctaHolder}`}
              >
                <>{cta}</>
              </div>
            ))}
        </div>

        <div className={`row`}>
          {sliderItems.map((item, idx) => (
            <div
              key={idx}
              className={`col-8 col-xl-4 ${
                textSliderSectionStyles.navigator
              }  ${
                category === item.id
                  ? textSliderSectionStyles.navigatorActive
                  : ``
              }`}
            >
              <a
                href="#!"
                onClick={evt => {
                  evt.preventDefault()
                  setCategory(item.id)
                }}
              >
                {item.label}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
